<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetClient widgetNoTopBorder widget-two-columns-one-gap-fifty-percent" *ngIf="(widgetData$ | async) as widgetData">
  <div class="fullWidth">
    <div class="table-part">
      <table class="widget-flex" style="height: 100%;" aria-hidden="true">
        <thead>
          <tr class="widget-ruller-flex">
            <th scope="col" class="widget-grid-column" colspan="20">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="4"><widget-label [widget]="this" [fieldName]="'valuationPortfolioClientManual'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="6"><widget-value [align]="'left'">{{widgetData.valuationPortfolioClientManual}}</widget-value></td>
            <td colspan="4"><widget-label [widget]="this" [fieldName]="'reportValuationClientContact'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="6"><widget-value [align]="'left'">{{widgetData.reportValuationClientContact}}</widget-value></td>
          </tr>
          <tr>
            <td colspan="4"><widget-label [widget]="this" [fieldName]="'reportValuationClientCompany'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="6"><widget-value [align]="'left'">{{widgetData.reportValuationClientCompany}}</widget-value></td>
            <td colspan="4"><widget-label [widget]="this" [fieldName]="'reportValuationCurrencyDescription'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="6"><widget-value [align]="'left'">{{widgetData.reportValuationCurrencyDescription}}</widget-value></td>
          </tr>
          <tr>
            <td colspan="4"><widget-label [widget]="this" [fieldName]="'reportValuationClientAddress'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="6"><widget-value [align]="'left'">{{widgetData.reportValuationClientAddress}}</widget-value></td>
            <td colspan="4"><widget-label [widget]="this" [fieldName]="'reportValuationPrimaryUse'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="6"><widget-value [align]="'left'">{{widgetData.reportValuationPrimaryUse}}</widget-value></td>
          </tr>
          <tr>
            <td colspan="4"><widget-label [widget]="this" [fieldName]="'reportValuationPropRefFileNo'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="6"><widget-value [align]="'left'">{{widgetData.reportValuationPropRefFileNo}}</widget-value></td>
            <td colspan="4">&nbsp;</td>
            <td colspan="6">&nbsp;</td>
          </tr>
          <tr><td colspan="20">&nbsp;</td></tr>
        </tbody>
      </table>
    </div>
    <div class="space-part">&nbsp;</div>
  </div>
</div>
